"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSimulationMode = void 0;
var _ = require("./");
var _shared = require("../shared");
var _react = require("react");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var useSimulationMode = function useSimulationMode(accountId) {
  var _useAuth = (0, _shared.useAuth)(),
    user = _useAuth.user,
    wipeIdentity = _useAuth.wipeIdentity;
  var navigateToTargetApp = (0, _react.useCallback)(function (resource) {
    wipeIdentity();
    window.location = resource;
  }, [wipeIdentity]);
  var _useUpdate = (0, _.useUpdate)({
      update: function () {
        var _update = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _.api.post((0, _.getSimulationUrl)(accountId));
                case 2:
                  res = _context.sent;
                  navigateToTargetApp(res.data.resource);
                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        function update() {
          return _update.apply(this, arguments);
        }
        return update;
      }()
    }),
    startSimulation = _useUpdate.handleSubmit,
    startingSimulation = _useUpdate.processing;
  var _useUpdate2 = (0, _.useUpdate)({
      update: function () {
        var _update2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var res;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _.api.delete((0, _.getSimulationUrl)(accountId));
                case 2:
                  res = _context2.sent;
                  navigateToTargetApp(res.data.resource);
                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        function update() {
          return _update2.apply(this, arguments);
        }
        return update;
      }()
    }),
    finishSimulation = _useUpdate2.handleSubmit,
    finishingSimulation = _useUpdate2.processing;
  return {
    isSimulationMode: user === null || user === void 0 ? void 0 : user.isSimulationMode,
    startSimulation: startSimulation,
    finishSimulation: finishSimulation,
    processingSimulation: startingSimulation || finishingSimulation
  };
};
exports.useSimulationMode = useSimulationMode;